import React from "react";

const TypingIndicator: React.FC = () => {
  return (
    <div className="typing-indicator">
      <span className="typing_ind_dot dot-1"></span>
      <span className="typing_ind_dot dot-2"></span>
      <span className="typing_ind_dot dot-3"></span>
    </div>
  );
};

export default TypingIndicator;
